export default "__VITE_ASSET__6005e71c__"